/* Kinbo cart tweaks:
   Barre cadeau Alo en orange/or (distincte de la barre livraison verte).
   Reordonne les lignes : articles payants d'abord, cadeaux ensuite, encadres "Offert". */
(function () {
  var CAP_PID = 15614720934236;   // Casquette Alo
  var SOCK_PID = 15614720999772;  // Chaussettes Alo

  function isGift(item) { return item.product_id === CAP_PID || item.product_id === SOCK_PID; }
  function eur(c) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; }
  function variantLabel(item) {
    var v = item.variant_title;
    return (v && v !== 'Default Title') ? v : '';
  }

  function injectStyles() {
    if (document.getElementById('kinbo-cart-tweaks')) return;
    var s = document.createElement('style');
    s.id = 'kinbo-cart-tweaks';
    s.textContent =
      '.gift-bar--reached{background:#fff7ed!important;border-bottom-color:#fde6c8!important}' +
      '.gift-bar--reached .gift-bar__text{color:#b45309!important}' +
      '.gift-bar--reached .gift-bar__fill{background:#f59e0b!important}' +
      '.kinbo-gift-row{display:flex;gap:12px;align-items:center;border:1px dashed #f59e0b;background:#fffaf0;border-radius:10px;padding:10px;margin-bottom:16px}' +
      '.kinbo-gift-row img{width:64px;height:64px;object-fit:cover;border-radius:8px;display:block;flex-shrink:0}' +
      '.kinbo-gift-badge{display:inline-block;background:#f59e0b;color:#fff;font-size:10px;font-weight:800;letter-spacing:.04em;padding:2px 7px;border-radius:99px;text-transform:uppercase}';
    document.head.appendChild(s);
  }

  function paidRow(item) {
    return '' +
      '<div style="display:flex;gap:12px;margin-bottom:16px;padding-bottom:16px;border-bottom:1px solid #f0f0f0;">' +
        '<a href="' + item.url + '" style="flex-shrink:0;display:block;"><img src="' + item.image + '" style="width:72px;height:72px;object-fit:cover;border-radius:8px;display:block;" /></a>' +
        '<div style="flex:1;min-width:0;">' +
          '<div style="display:flex;align-items:flex-start;justify-content:space-between;gap:8px;">' +
            '<div style="flex:1;min-width:0;">' +
              '<p style="font-size:13px;font-weight:700;margin:0 0 4px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"><a href="' + item.url + '" style="color:inherit;text-decoration:none;">' + item.product_title + '</a></p>' +
              '<p style="font-size:12px;color:#666;margin:0 0 6px;">' + variantLabel(item) + '</p>' +
            '</div>' +
            '<button onclick="removeItem(\'' + item.key + '\')" style="background:none;border:none;cursor:pointer;padding:4px;line-height:1;flex-shrink:0;opacity:0.6;" title="Supprimer" aria-label="Supprimer"><img src="https://cdn.shopify.com/s/files/1/1006/6011/7852/files/bin.png?v=1780529900" alt="" width="18" height="18" style="display:block;"></button>' +
          '</div>' +
          '<div style="display:flex;align-items:center;justify-content:space-between;">' +
            '<span style="font-size:14px;font-weight:800;">' + eur(item.final_price) + '</span>' +
            '<div style="display:flex;align-items:center;gap:8px;">' +
              '<button onclick="updateQty(\'' + item.key + '\', ' + (item.quantity - 1) + ')" style="width:24px;height:24px;border:1px solid #ddd;border-radius:50%;background:#fff;cursor:pointer;font-size:14px;display:flex;align-items:center;justify-content:center;">−</button>' +
              '<span style="font-size:13px;font-weight:600;">' + item.quantity + '</span>' +
              '<button onclick="updateQty(\'' + item.key + '\', ' + (item.quantity + 1) + ')" style="width:24px;height:24px;border:1px solid #ddd;border-radius:50%;background:#fff;cursor:pointer;font-size:14px;display:flex;align-items:center;justify-content:center;">+</button>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>';
  }

  function giftRow(item) {
    return '' +
      '<div class="kinbo-gift-row">' +
        '<img src="' + item.image + '" />' +
        '<div style="flex:1;min-width:0;">' +
          '<p style="font-size:13px;font-weight:700;margin:0 0 4px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">' + item.product_title + '</p>' +
          '<p style="font-size:12px;color:#666;margin:0 0 6px;">' + variantLabel(item) + '</p>' +
          '<div style="display:flex;align-items:center;gap:8px;">' +
            '<span class="kinbo-gift-badge">Offert</span>' +
            '<span style="font-size:13px;font-weight:800;color:#b45309;">0,00 €</span>' +
          '</div>' +
        '</div>' +
      '</div>';
  }

  async function rerender() {
    var container = document.getElementById('cart-drawer-items');
    if (!container) return;
    var cart;
    try { cart = await (await fetch('/cart.js')).json(); } catch (e) { return; }
    if (!cart || !cart.items || !cart.items.length) return;
    var hasgifts = cart.items.some(isGift);
    if (!hasgifts) return; // only rerender if there are gift items
    var paid = [], gifts = [];
    cart.items.forEach(function (it) { (isGift(it) ? gifts : paid).push(it); });
    container.innerHTML = paid.map(paidRow).join('') + gifts.map(giftRow).join('');
  }

  function wrap() {
    if (typeof window.loadCart !== 'function') return false;
    if (window.__kinboTweaksWrapped) return true;
    var orig = window.loadCart;
    window.loadCart = function () {
      var r = orig.apply(this, arguments);
      Promise.resolve(r).then(function () { rerender(); });
      return r;
    };
    window.__kinboTweaksWrapped = true;
    return true;
  }

  function init() {
    injectStyles();
    if (!wrap()) {
      var t = 0, iv = setInterval(function () { t++; if (wrap() || t > 60) clearInterval(iv); }, 150);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
